<template>
  <UTooltip
    :text="isVisible ? 'Hide Review' : 'Show Review'"
  >
    <UButton
      type="button"
      size="xs"
      :icon="isVisible ? 'ri:eye-off-line' : 'ri:eye-line'"
      :color="isVisible ? 'red' : 'green'"
      class="text-white"
      @click="toggleReviewVisibility"
    >
      {{ isVisible ? 'Hide' : 'Show' }}
    </UButton>
  </UTooltip>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{ id: string, visible?: boolean }>(), {
  visible: true,
})
const pb = useNuxtApp().$pb
const toast = useToast()
const isVisible = ref(props.visible)
const emit = defineEmits<{
  (event: 'hidden'): void
  (event: 'visibility-changed', value: boolean): void
}>()

watch(() => props.visible, (value) => {
  isVisible.value = value ?? true
}, { immediate: true })

async function toggleReviewVisibility() {
  const previousVisibility = isVisible.value
  const nextVisibility = !previousVisibility

  isVisible.value = nextVisibility

  try {
    await pb.send(`/toggle-review-visibility/${props.id}`, { method: 'POST' })
    toast.add({ description: `Review ${nextVisibility ? 'shown' : 'hidden'} successfully` })
    emit('visibility-changed', nextVisibility)
    if (!nextVisibility) {
      emit('hidden')
    }
  }
  catch (error) {
    isVisible.value = previousVisibility
    const message = error && typeof error === 'object' && 'response' in error
      ? (error.response as { error?: string })?.error
      : undefined
    toast.add({ description: message ?? 'Could not update review visibility', color: 'red' })
  }
}
</script>

<style scoped>

</style>
